import { Injectable } from '@angular/core';
import { Plan, PlanningProfile } from '@app/shared/models';
import { PlanningService } from '@app/shared/services/planning.service';
import { AccountService } from '@app/shared/services/account.service';
import { Subject } from 'rxjs/Subject';
import { ActivatedRoute } from '@angular/router';
import {ProfileService} from '@app/shared/services/profile.service';

@Injectable()
export class DatepickerService {
  profiles: PlanningProfile[] = [];
  plans: Plan[] = [];
  weekNumber;
  datesString;
  commonPlansPrice: number;
  datePicker = new Date();
  thisWeekFull: number;
  profilesId: number[];

  private showWeekSource = new Subject();
  public showWeek$ = this.showWeekSource.asObservable();

  constructor(
    private route: ActivatedRoute,
    private planningService: PlanningService,
    private accountService: AccountService,
    private profileService: ProfileService,
  ) { }

  showWeek() {
    this.planningService.fastMenuList.forEach( (currentValue) => {
      if (currentValue.amount > 0) {
        currentValue.amount = 0;
      }
    });
    this.getWeek(true);
  }

  /**Вывод дат текущей недели и обновление использованных рецептов */
  getWeek(force: boolean = false): Promise<number> {
    return new Promise<number>(resolve => {
      const date = new Date(Date.UTC(this.datePicker.getFullYear(), this.datePicker.getMonth(), this.datePicker.getDate()));
      const prevWeekNumber = this.weekNumber;
      date.setDate(date.getDate() + 7);
      this.weekNumber = this.planningService.getWeekNumber(date);

      if (prevWeekNumber !== this.weekNumber || force) {
        const first = date.getTime() - date.getDay() * 86400000 + 86400000;
        const last = first + 6 * 86400000;
        this.datesString = this.planningService.getWeekDateRangeString(new Date(first), new Date(last));

        this.thisWeekFull = this.weekNumber;
        this.planningService.refreshCurrentWeekRecipes(this.weekNumber, true);
        this.profileService.getProfilesAndPlans(this.weekNumber).then( (plan) => {
          this.profilesId = this.profileService.planningProfiles.map(user => user.Id);
          this.planningService.countAmountRecipesInFastMenuList(plan, this.profilesId[this.planningService.activeProfile]);
        });
      }

      resolve(this.weekNumber);
    });
  }

  changeWeek(direction: boolean) {
    this.datePicker = new Date(this.datePicker.getTime() + (direction ? 1 : -1) * 604800000);
    this.showWeek();
    this.showWeekSource.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/datepicker.service.ts